<template>
  <v-checkbox v-model="value" :label="itemLabel" hide-details="auto" />
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import { ParamField } from "../enums/ParamField";
import { useModbusStore } from "@/stores/useModbusStore";

const modbusStore = useModbusStore();
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const value = ref(false);

watch(value, (newValue) => {
  modbusStore.selectedQuickParams[props.item[ParamField.mbusAddress]] =
    newValue;
});

const storeValue = computed(() => {
  return modbusStore.selectedQuickParams[props.item[ParamField.mbusAddress]];
});

watch(storeValue, () => {
  value.value = storeValue.value;
});

onMounted(() => {
  value.value =
    modbusStore.selectedQuickParams[props.item[ParamField.mbusAddress]];
});

const itemLabel = computed(() => {
  if (props.item.sub_group == "0") {
    return `${props.item.name} ( ${props.item.group} )`;
  } else {
    return `${props.item.name} ( ${props.item.group} / ${props.item.sub_group} )`;
  }
});
</script>
